import script from "./FileString.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileString.vue?vue&type=script&setup=true&lang=ts"

import "./FileString.vue?vue&type=style&index=0&id=46438e2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46438e2c"]])

export default __exports__